import { render, staticRenderFns } from "./SliderSection.vue?vue&type=template&id=577c5034&"
import script from "./SliderSection.vue?vue&type=script&lang=js&"
export * from "./SliderSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SwiperCarrousel: require('/codebuild/output/src1887633789/src/kokalanov/components/SwiperCarrousel.vue').default})
